<template>
  <v-switch
    class="ml-2"
    inset
    v-model="item.value"
    :label="item.label"
    :disabled="disabled || item.readonly"
    @change="onChange"
  >
<!--     <template v-slot:label>
      {{item.label}}
      <br/><div class="text-caption" >{{item.hint}}</div>
    </template> -->
  </v-switch>
</template>

<script>
  export default {
    name: 'p-switch',
    props: {
      item: Object,
      disabled: { type: Boolean, default: false },
      updateTrigger: Number,
      defaultUsed: { type: Boolean, default: false }
    },
    data: () => ({
    }),
    mounted() {
      if (this.item.default && !this.defaultUsed) {
        this.onChange(this.item.default, true)
      }
    },    
    watch:{
      updateTrigger() {
        this.$forceUpdate()
      }
    },
    methods: {
      onChange(value, defaultUsed) {
        this.$emit('change', { model: this.item.model, subModel: this.item.subModel, value, defaultUsed, checkDefault: this.item.checkDefault })
      }
    }
  }
</script>